/**
 * Wedding Service — Core wedding CRUD + dashboard data
 */
import api from './api';

const weddingService = {
  getMyWedding: () => api.get('/weddings/mine').then(r => r.data),
  createWedding: (data) => api.post('/weddings', data).then(r => r.data),
  updateWedding: (data) => api.put('/weddings/mine', data).then(r => r.data),
  getDashboardSummary: () => api.get('/weddings/dashboard-summary').then(r => r.data),
  onboard: (data) => api.post('/weddings/onboard', data).then(r => r.data)
};

export default weddingService;
